import React from 'react';
import ReactDOM from 'react-dom';
import Calculator from './components/Calculator';
import './styles/app.css';

ReactDOM.render(
  <Calculator />,
  document.getElementById('root'),
);
